import React from 'react'

const Award = () => {
  return (
    <svg viewBox="0 0 65 65">
      <g>
        <rect x="26.7" y="30.6" fill="#FFF" width="12.6" height="21.3"/>
        <path fill="#3F5063" d="M39.8,52.3H26.2V30.1h13.6V52.3z M27.2,51.3h11.6V31.1H27.2V51.3z"/>
      </g>
      <g>
        <rect x="29.6" y="30.6" fill="#FFF" width="6.8" height="24.2"/>
        <path fill="#3F5063" d="M36.9,55.2h-7.8V30.1h7.8V55.2z M30.1,54.2h5.8V31.1h-5.8V54.2z"/>
      </g>
      <g>
        <ellipse fill="#FFF" cx="32.5" cy="23.3" rx="13.1" ry="13.5"/>
        <path fill="#3F5063" d="M32.5,37.3c-7.5,0-13.6-6.3-13.6-14s6.1-14,13.6-14s13.6,6.3,13.6,14S40,37.3,32.5,37.3z M32.5,10.2
		c-6.9,0-12.6,5.9-12.6,13s5.6,13,12.6,13c6.9,0,12.6-5.9,12.6-13S39.4,10.2,32.5,10.2z"/>
      </g>
      <g>
        <polygon fill="#FFF" points="32.5,26.4 29.4,28.1 30,24.6 27.4,22.1 30.9,21.6 32.5,18.5 34.1,21.6 37.6,22.1
		35,24.6 35.6,28.1 	"/>
        <path fill="#6EC18A" d="M36.3,29l-3.8-2l-3.8,2l0.7-4.2l-3.1-3l4.2-0.6l1.9-3.8l1.9,3.8l4.2,0.6l-3.1,3L36.3,29z M28.5,22.5l2,1.9
		L30,27.2l2.5-1.3l2.5,1.3l-0.5-2.7l2-1.9l-2.8-0.4l-1.2-2.5l-1.2,2.5L28.5,22.5z"/>
      </g>
    </svg>
  )
}

export default Award
